import React, { useState } from "react";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

import ThemeList from "./ThemeList";

import style from "../../style.module.css";

const ThemeListCollection = (props) => {
  const { themeList, themeSlug, setThemeSlug, disableAllEdits } = props;

  const [isExpanded, setExpanded] = useState(false);

  return (
    <>
      {themeList
        .filter((theme, index) => (isExpanded ? true : index < 4))
        .map((theme) => (
          <ThemeList
            key={theme.slug}
            theme={theme}
            themeSlug={themeSlug}
            setThemeSlug={setThemeSlug}
            disableAllEdits={disableAllEdits}
          />
        ))}
      {themeList.length > 4 ? (
        <div
          className={style.expandThemes}
          onClick={() => setExpanded(!isExpanded)}
        >
          Show&nbsp;
          {isExpanded ? (
            <>
              Less
              <ExpandLessIcon />
            </>
          ) : (
            <>
              More ({themeList.length - 4})
              <ExpandMoreIcon />
            </>
          )}
        </div>
      ) : null}
    </>
  );
};

export default ThemeListCollection;
